<template>
  <div>
    <div class="content">
      <div class="content-add-detail">
        <el-form :model="queryParams" class="demo-form-inline" label-position="left">
          <div class="add-basic-information">
            <div class="add-title">
              <span class="basic title-font-style">备货信息</span>
            </div>
            <div
              class="add-content details-line-height"
              style="padding-left:50px;padding-bottom:10px"
            >
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="备货编号：">
                      <span>{{ queryParams.stockupCode || '--'}}</span>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="备货方式：">
                      <span>
                        {{
                        distributionType === 1
                        ? '仓储备货'
                        : '调拨备货' || '--'
                        }}
                      </span>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="预计发货时间：">
                      <span>{{queryParams.deliveryTime|dateFilterD}}</span>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="备货仓库：">
                      {{
                      queryParams.storageName || '--'
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="联系电话：">
                      {{
                      queryParams.storagePhone || '--'
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col>
                    <el-form-item label="仓库地址：">
                      {{
                      queryParams.storageAddress || '--'
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="发起人：">{{queryParams.createUser}}</el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="请求备货时间：">
                      {{queryParams.createDate | dateFilterL
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="add-basic-information">
            <div class="add-title add-title1" style="padding-left:20px;padding-top:20px">
              <div>
                <span class="basic title-font-style">{{ '调拨产品清单'}}</span>
              </div>
              <span style="text-align:right;padding-right:20px;">
                <el-button @click="toExport" plain>导出备货单</el-button>
              </span>
            </div>
            <div class="box-table">
              <el-table
                max-height="378"
                border
                ref="tableRef"
                tooltip-effect="dark"
                :data="list"
                :header-cell-style="tableHeader"
                v-loading="loadingTable"
                element-loading-text="拼命加载中请稍后..."
                element-loading-spinner="el-icon-loading"
                v-if="stockupState === 2"
                :row-class-name="isCheck"
               >
                <el-table-column label="品牌" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.brandName}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="proName" label="产品名称" width="110px" show-overflow-tooltip></el-table-column>
                <el-table-column label="型号" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div
                      class="approval line-limit-length"
                      @click="detailModel(scope.row)"
                    >{{scope.row.proModel}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="订货号" width="130px" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.proOrdernum}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="单位" width="80px">
                  <template slot-scope="scope">
                    <div>{{scope.row.proUnit}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="所在仓库" width="120px" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.storageName}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="货架" width="80px" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.shelvesName}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="备货数量" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div>{{ scope.row.stockupCount }}</div>
                  </template>
                </el-table-column>
                <el-table-column width="120px" label="货架库存量" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div>{{scope.row.counts}}</div>
                  </template>
                </el-table-column>
                <el-table-column width="120px" label="历史已锁库" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div>{{scope.row.lockCounts}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="入库批次"
                  width="140px"
                  show-overflow-tooltip
                  v-if="stockupState === 2"
                >
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.warehouseBatchCode || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column width="120px" :label="'本次调拨数量'" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div>{{scope.row.lockCount}}</div>
                  </template>
                </el-table-column>
                <el-table-column width="140px" :label="'修正后货架库存量'" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div>{{scope.row.count}}</div>
                  </template>
                </el-table-column>
                <el-table-column width="120px" :label="'本次调拨数量'" v-if="stockupState !== 2">
                  <template slot-scope="scope">
                    <div>{{scope.row.lockCount}}</div>
                  </template>
                </el-table-column>
                <el-table-column width="120px" label="货架库存量" v-if="stockupState !== 2">
                  <template slot-scope="scope">
                    <div>{{scope.row.counts}}</div>
                  </template>
                </el-table-column>
                <el-table-column width="120px" label="历史已锁库" v-if="stockupState !== 2">
                  <template slot-scope="scope">
                    <div>{{scope.row.lockCounts}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="入库批次"
                  width="160px"
                  show-overflow-tooltip
                  v-if="stockupState !== 2"
                >
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.warehouseBatchCode}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="备注" show-overflow-tooltip v-if="stockupState !== 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.mark || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toVacancy(scope.row)"
                      v-show="scope.row.isLack&& scope.row.isCheck"
                    >报缺</el-button>
                    <el-button
                      type="text"
                      @click="toVacancy(scope.row,scope.row)"
                      v-show="!scope.row.isLack"
                    >查看</el-button>
                    <el-button
                      type="text"
                      @click="colorVacancy(scope.$index,scope.row)"
                      v-show="scope.row.isLack && !scope.row.isCheck"
                    >报缺</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-table
               max-height="378"
                border
                ref="tableRef"
                tooltip-effect="dark"
                :data="list"
                :header-cell-style="tableHeader"
                v-loading="loadingTable"
                element-loading-text="拼命加载中请稍后..."
                element-loading-spinner="el-icon-loading"
                v-if="stockupState !== 2"
              >
                <el-table-column label="品牌" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.brandName}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="产品名称" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.proName}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="型号" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div
                      class="approval line-limit-length"
                      @click="detailModel(scope.row)"
                    >{{scope.row.proModel}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="订货号" width="130px" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.proOrdernum}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="单位" width="80px">
                  <template slot-scope="scope">
                    <div>{{scope.row.proUnit}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="所在仓库" width="120px" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.storageName || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="货架" width="80px" prop="shelvesName" show-overflow-tooltip></el-table-column>
                <el-table-column label="备货数量" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div>{{ scope.row.stockupCount }}</div>
                  </template>
                </el-table-column>
                <el-table-column width="120px" label="货架库存量" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div>{{scope.row.counts}}</div>
                  </template>
                </el-table-column>
                <el-table-column width="120px" label="历史已锁库" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div>{{scope.row.lockCounts}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="入库批次"
                  width="140px"
                  show-overflow-tooltip
                  v-if="stockupState === 2"
                >
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.warehouseBatchCode || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column width="120px" :label="'本次调拨数量'" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div>{{scope.row.lockCount}}</div>
                  </template>
                </el-table-column>
                <el-table-column width="140px" :label="'修正后货架库存量'" v-if="stockupState === 2">
                  <template slot-scope="scope">
                    <div>{{scope.row.count}}</div>
                  </template>
                </el-table-column>
                <el-table-column width="120px" :label="'本次调拨数量'" v-if="stockupState !== 2">
                  <template slot-scope="scope">
                    <div>{{scope.row.lockCount}}</div>
                  </template>
                </el-table-column>
                <el-table-column width="120px" label="货架库存量" v-if="stockupState !== 2">
                  <template slot-scope="scope">
                    <div>{{scope.row.counts}}</div>
                  </template>
                </el-table-column>
                <el-table-column width="120px" label="历史已锁库" v-if="stockupState !== 2">
                  <template slot-scope="scope">
                    <div>{{scope.row.lockCounts}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="入库批次"
                  width="160px"
                  show-overflow-tooltip
                  v-if="stockupState !== 2"
                >
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.warehouseBatchCode || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="备注" show-overflow-tooltip v-if="stockupState !== 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.mark || '--'}}</div>
                  </template>
                </el-table-column>
              </el-table>
              <div
                class="add-basic-information"
                v-if="stockupState === 1 || stockupState === 2"
                style="padding:14px 0 0 0px;margin-top:0px"
              >
                <div
                  style="font-size:12px;color:#D35E5E;"
                >*备货及发货过程中如发现缺失，可点击报缺按钮，修改备货方案并提交报缺。产品清单中标红产品所在货架正存在盘点任务，不允许发起报缺。</div>
                <div
                  style="font-size:12px;margin-bottom:10px;color:#D35E5E;"
                >如货架产品存在报缺，且影响备货，可等待盘点任务结束后进行备货，如不影响备货可直接确认备货</div>
              </div>
            </div>
          </div>
        </el-form>

        <!-- -------------------------- 调拨备货 待处理，待认领页面------- -------   ---------------------------------- -->
        <div
          class="add-basic-information"
          v-if="stockupState === 1 || stockupState === 2"
          style="padding:20px 0px 20px 37px; "
        >
          <el-form
            :rules="paramsRules"
            ref="paramsRefs"
            :model="params"
            label-width="90px"
            :label-position="labelPosition"
          >
            <el-row>
              <el-col :span="8">
                <el-form-item label="调拨方式：">
                  <el-select v-model="deliverType" style="width:60%">
                    <el-option
                      v-for="(item, index) in allocationMethod"
                      :key="index"
                      :label="item.label"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!------------------------------仓库配送------------------------------------------------->
              <el-col :span="8" v-if="deliverType === '仓库配送'">
                <el-form-item label="预计到达时间：" label-width="100px">
                  <el-date-picker
                    v-model="queryParams.arrivalTime"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="年/月/日"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="deliverType === '仓库配送'">
              <el-col>
                <el-form-item label="发货说明：">
                  <el-input
                    style="width:80%"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 3 }"
                    v-model="queryParams.remark"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div v-if="deliverType !== '仓库配送'">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="快递公司：" :rules="filter_rules({required:true})">
                    <el-select
                      @change="selectCompany"
                      v-model="logicType"
                      placeholder
                      style="width:60%"
                    >
                      <el-option
                        v-for="(item, index) in stockProcessedType"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <div v-if="logicType===1">
                <div style="font-weight:bold;padding:0 0 10px 0px;">{{'德邦快递信息'}}</div>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="下单模式：" prop="orderType">
                      <el-select
                        @change="selectOrderType"
                        v-model="params.orderType"
                        style="width:60%"
                      >
                        <el-option
                          v-for="(item, index) in orderPattern"
                          :key="index"
                          :label="item.label"
                          :value="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="运输方式： " prop="transportType">
                      <el-select
                        style="width:60%"
                        @change="selectTransportType(params.transportType)"
                        v-model="params.transportType"
                      >
                        <el-option
                          v-for="(item, index) in transportation"
                          :key="index"
                          :label="item.label"
                          :value="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="产品类型：" prop="productType">
                      <el-select
                        style="width:60%"
                        @change="selectProductType(params.productType)"
                        v-model="params.productType"
                      >
                        <el-option
                          v-for="(item,index) in tempArr"
                          :key="index"
                          :label="item"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <div style="font-weight:bold;padding:0 0 10px 0px;;">包裹信息</div>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="总件数：" prop="totalNumber">
                      <el-input
                        style="width:60%"
                        v-model.trim="params.totalNumber"
                        placeholder="若不知具体数值，可写为默认值1"
                        oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="包装：">
                      <el-input
                        v-model.trim="params.packageService"
                        placeholder="包装方式：纸，木箱，木架等"
                        style="width:60%"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" prop="deliveryType">
                    <el-form-item label="送货方式：">
                      <el-select
                        style="width:60%"
                        @change="selectDeliveryType(params.deliveryType)"
                        v-model="params.deliveryType"
                      >
                        <el-option
                          v-for="(item, index) in shipping"
                          :key="index"
                          :label="item.label"
                          :value="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="支付方式：" prop="payType">
                      <el-select
                        @change="selectPayType(params.payType)"
                        v-model="params.payType"
                        style="width:60%"
                      >
                        <el-option
                          v-for="(item, index) in payment"
                          :key="index"
                          :label="item.label"
                          :value="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <div style="font-weight:bold;padding-bottom:10px;padding-left:5px;">增值服务</div>
                  <el-col :span="8" style="padding:0;">
                    <el-form-item label="保价金额：">
                      <el-input v-model="params.insuranceValue" style="width:60%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="签收回单：" prop="backSignBill">
                      <el-select
                        style="width:60%"
                        @change="selectBackSignBill(params.backSignBill)"
                        v-model="params.backSignBill"
                      >
                        <el-option
                          v-for="(item, index) in signReceipt"
                          :key="index"
                          :label="item.label"
                          :value="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <!-- 自定义 -->
              <div v-if="logicType ===2">
                <el-form :label-position="labelPosition" label-width="90px">
                  <span class="logistics-information">物流信息</span>
                  <el-row v-for="(item,index) in addListParams.addList" :key="index">
                    <el-col :span="8">
                      <el-form-item label="物流公司：" :rules="filter_rules({required:true})">
                        <el-input  maxlength="200" v-model.trim="item.logicCompany" style="width:60%"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="物流单号：" :rules="filter_rules({required:true})">
                        <el-input   maxlength="200" v-model.trim="item.logicNumber" style="width:90%"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-button
                        @click="toAddLogistic(addListParams.addList)"
                        v-if="index == 0"
                        type="primary"
                        plain
                      >添加物流</el-button>
                      <el-button
                        @click="toDelLogistic(addListParams.addList,index)"
                        v-if="index> 0"
                        type="danger"
                        plain
                      >删除</el-button>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div v-if="logicType===3">
                <div style="font-weight:bold;padding-bottom:10px;">{{'中通快递信息'}}</div>
                <el-form-item label="注意事项：">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 3 }"
                    v-model="params.remark"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </el-form>
          <el-button
            style="margin-top:20px;"
            v-if="stockupState === 1 || stockupState === 2"
            type="primary"
            @click="onSureStock"
          >
            {{
            distributionType === 1 ? '确认备货' : '确认发货'
            }}
          </el-button>
        </div>
        <!-- -----------------------------------------------调拨备货 未揽件，物流订单管理详情页面 ----------------------------->
        <div class="add-basic-information" v-if="stockupState === 4">
          <el-form
            :label-position="labelPosition"
            v-model="collect"
            label-width="90px"
            style="padding: 20px"
            :rules="queryParamsRules"
            ref="queryParamsRefs"
            :model="collect"
          >
            <!--   ------------------------------------物流配送-------------------------- -->
            <el-row>
              <div style="font-weight:bold;padding-bottom:10px;">快递物流信息</div>
              <el-col :span="8">
                <el-form-item label="运单号：">
                  <el-input disabled v-model="collect.mailNos" style="width:80%;"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="子单号：">
                  <el-input disabled v-model="collect.mailNo" style="width:80%;"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="运输方式： " prop="transportType">
                  <el-select
                    style="width:80%;"
                    :disabled="banned"
                    @change="selectTransportType(collect.transportType)"
                    v-model="collect.transportType"
                  >
                    <el-option
                      v-for="(item, index) in transportation"
                      :key="index"
                      :label="item.label"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="产品类型：" prop="productType">
                  <el-select
                    style="width:80%;"
                    @change="selectProductType(collect.productType)"
                    v-model="collect.productType"
                    :disabled="banned"
                  >
                    <el-option
                      v-for="(item,index) in tempArr"
                      :key="index"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="运单状态：">
                  <el-input disabled v-model="collect.result" style="width:80%;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div style="font-weight:bold;padding-bottom:10px;">包裹信息</div>
            <el-row>
              <el-col :span="8">
                <el-form-item label="送货方式：" prop="deliveryType">
                  <el-select
                    style="width:80%;"
                    :disabled="banned"
                    @change="selectDeliveryType(collect.deliveryType)"
                    v-model="collect.deliveryType"
                  >
                    <el-option
                      v-for="(item, index) in shipping"
                      :key="index"
                      :label="item.label"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="总件数：" prop="totalNumber">
                  <el-input
                    style="width:80%;"
                    :disabled="banned"
                    v-model.trim="collect.totalNumber"
                    placeholder="若不知具体数值，可写为默认值1"
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="总重量（kg）：" prop="totalWeight" label-width="115px">
                  <el-input
                    style="width:80%;"
                    :disabled="banned"
                    v-model.trim="collect.totalWeight"
                    placeholder="若不知具体数值，可写为默认值1"
                    oninput="value=value.replace(/^(0+)|[^0-9.]+/g,'')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="包装：">
                  <el-input
                    style="width:80%;"
                    :disabled="banned"
                    v-model="collect.packageService"
                    placeholder="包装方式：纸，木箱，木架等"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="支付方式：" prop="payType">
                  <el-select
                    style="width:80%;"
                    :disabled="banned"
                    @change="selectPayType(collect.payType)"
                    v-model="collect.payType"
                  >
                    <el-option
                      v-for="(item, index) in payment"
                      :key="index"
                      :label="item.label"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="注意事项：">
                  <el-input
                    style="width:95%;"
                    :disabled="banned"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 3 }"
                    v-model="collect.remark"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div style="font-weight:bold;padding-bottom:10px;">增值服务</div>
            <el-row>
              <el-col :span="8">
                <el-form-item label="保价金额：">
                  <el-input v-model="collect.insuranceValue" :disabled="banned" style="width:80%;"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="签收回单：" prop="backSignBill">
                  <el-select
                    style="width:80%;"
                    @change="selectBackSignBill(collect.backSignBill)"
                    v-model="collect.backSignBill"
                    :disabled="banned"
                  >
                    <el-option
                      v-for="(item, index) in signReceipt"
                      :key="index"
                      :label="item.label"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div style="margin-top:15px;padding-left:30px;">
            <span v-if="banned">
              <el-button
                type="primary"
                @click="editLogistics"
                style="padding-right:10px;margin-bottom:30px;"
              >修改物流备货单</el-button>
              <el-button plain @click="repealLogistics">撤销快递物流单</el-button>
              <el-button plain>打印快递物流单</el-button>
            </span>
            <span v-else style="margin-bottom:30px;">
              <el-button type="primary" @click="ModifyComplete">修改完成</el-button>
              <el-button @click="backLogistics">返回</el-button>
            </span>
          </div>
        </div>
        <!-- -------------------------------------------------调拨备货已处理，处理结果页面---- ------------------------------- -->
        <div
          v-if="stockupState === 3"
          class="add-basic-information"
          style="padding-top:20px;padding-left:20px;"
         >
          <el-form>
            <div>
              <el-row v-show="wareHouse.logicType === 2">
                <el-col :span="20">
                  <el-form-item label="调拨方式：">
                    <span>物流配送</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-for="(item,index) in wareHouse.storageLogisticsVoList"
                :key="index"
                v-show="wareHouse.logicType === 2"
              >
                <el-col :span="6">
                  <el-form-item label="物流公司：">
                    <span>
                      {{
                      item.logicCompany || '--'
                      }}
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="物流单号：">
                    <span>
                      {{
                      item.logicNumber || '--'
                      }}
                    </span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-show="wareHouse.logicType === 2">
                <el-col :span="6">
                  <el-form-item label="处理人：">
                    <span>{{ wareHouse.createUser || '--'}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="发货时间：">
                    <span>{{ wareHouse.outDate|dateFilterL }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-show="wareHouse.deliverType === '仓库配送'">
                <el-col :span="20">
                  <el-form-item label="调拨方式：">
                    <span>{{ wareHouse.deliverType || '--'}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="处理人：">
                    <span>{{ wareHouse.createUser || '--'}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="预计到达时间：">
                    <span>{{ wareHouse.arrivalTime | dateFilterD }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="发货说明：">
                    <span>{{ wareHouse.mark || '--'}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <span
                style="font-weight: bold;"
                v-if="wareHouse.logicType === 1 && conseQuence !== null"
              >物流信息</span>
              <el-row v-if="wareHouse.logicType === 1 && conseQuence !== null">
                <el-col :span="6">
                  <el-form-item label="快递公司：">
                    <span>{{ conseQuence.company || '--'}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="快递单号：">
                    <span>{{ conseQuence.mailNos || '--'}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="子单号：">
                    <span>{{ conseQuence.mailNo || '--'}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="订单状态：">
                    <span>{{ conseQuence.state || '--'}}</span>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item label="处理人：">
                    <span>{{ conseQuence.createUser || '--' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="总重量：">
                    <span>
                      {{
                      conseQuence.totalWeight || '--'
                      }}
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="总件数：">
                    <span>
                      {{
                      conseQuence.totalNumber || '--'
                      }}
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="总价格：">
                    <span>{{ conseQuence.money || '--'}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="保价金额：">
                    <span>
                      {{
                      conseQuence.insuranceValue || '--'
                      }}
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="发货时间：">
                    <span>{{ conseQuence.createDate|dateFilterL }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
        <!-- --------物流订单管理详情-撤单提示框 ------------------>
        <el-dialog
          title="撤销物流快递订单"
          :visible.sync="dialogVisible"
          onVacancyidth="503px"
          @close="close"
        >
          <el-form
            style="padding-left:30px;"
            :rules="queryParamsRules"
            ref="queryParamsRefs"
            :model="collect"
            :label-position="labelPosition"
            label-width="110px"
          >
            <el-row>
              <el-col :span="10">
                <el-form-item label="运单号：" prop="mailNos">
                  <el-input :disabled="banned" v-model="collect.mailNos"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="撤销订单备注：" prop="Mark">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 4 }"
                    v-model.trim="Mark"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer">
            <el-button @click="goBack">返回</el-button>
            <el-button type="primary" @click="affirmBackout">确认撤销</el-button>
          </span>
        </el-dialog>
        <!-------------- 备货确认提示框 -------------------------->
        <sure-stock-tip
          ref="sureStockTipRefs"
          @entryProcessed="entryProcessed"
          @entryLogistics="entryLogistics"
        ></sure-stock-tip>
        <!-------------- 报缺方案提交信息侧边栏 ------------------->
        <submission-of-vacancis ref="sureStockTipsRefs" @getList="getListRef"></submission-of-vacancis>
        <!-------------修改完成提示框 ---------->
        <el-dialog :visible.sync="disableDialog" class="dialog-address" width="437px" title="修改确认">
          <div class="dialog-tip" style="padding-left:30px;">确定已经修改完成？</div>
          <span slot="footer" class="dialog-center">
            <el-button @click="onSubmit" type="primary">确定</el-button>
            <el-button @click="disableDialog=false">取消</el-button>
          </span>
        </el-dialog>
        <!-- ----------撤单确认框------------ -->
        <el-dialog :visible.sync="backDialog" class="dialog-address" width="437px" title="撤销确认">
          <div class="dialog-tip" style="padding-left:30px;">确定撤销物流发货单？</div>
          <div class="dialog-tip" style="padding-left:30px;">撤销后，发起人重新选择发货方式</div>
          <span slot="footer" class="dialog-center">
            <el-button @click="onBackSubmit" type="primary">确定</el-button>
            <el-button @click="cancle">取消</el-button>
          </span>
        </el-dialog>
        <!-- ------------ 存在盘点无法报缺----------------->
        <el-dialog :visible.sync="checkDialog" class="dialog-address" width="437px" title="提示">
          <div class="dialog-tip" style="padding-left:30px;">该产品所在货架存在盘点任务不允许发起报缺.</div>
          <span slot="footer" class="dialog-center">
            <el-button @click="checkDialog=false" type="primary">确定</el-button>
            <el-button @click="checkDialog=false">取消</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryStockupContentAllot,
  updateStorageDeliverLogisticBond,
  deleteStorageDeliverBond,
  queryStockupContent
} from '@/api/storage/storage'
import { downLoadFileBlob } from '@/util/tool'
import { addStorageStockCoeDerive } from '@/api/purchase/purchaseManage'
import sureStockTip from '../dialog/sureStockTip'
import stockProcessSlier from '../slideBar/stockProcessSlier'
import { revocationRules, deliverGoodsRules } from '../util/formRules' // 校验
import {
  stockProcessedType,
  allocationMethod,
  orderPattern,
  transportation,
  shipping,
  payment,
  signReceipt
} from '../util/data'

export default {
  components: {
    'sure-stock-tip': sureStockTip,
    'submission-of-vacancis': stockProcessSlier
  },
  data() {
    return {
      checkDialog: false,
      isLack: true,
      queryParamsRules: revocationRules, // 未揽件校验
      paramsRules: deliverGoodsRules, // 待备货校验
      labelPosition1: 'left',
      labelPosition: 'right', // 表单对齐方式
      forbidden: true,
      banned: true,
      backDialog: false,
      editDialog: false,
      disableDialog: false,
      dialogVisible: false,
      title: '',
      list: [], // 备货列表
      queryParams: {}, // 表单数据
      query: {
        logicCompany: '',
        logicNumber: ''
      }, // 调拨备货表单数据
      pitchOnPpId: [],
      loadingTable: false,
      isUpdate: false,
      stockProcessedType: stockProcessedType, // 快递公司
      allocationMethod: allocationMethod, // 调拨方式
      orderPattern: orderPattern, // 下单模式
      transportation: transportation, // 运输方式
      tempArr: [], // 产品类型临时数组
      shipping: shipping, // 送货方式
      payment: payment, // 支付方式
      signReceipt: signReceipt, // 签收回单
      distributionType: 2, // 备货方式 1仓储备货 2调拨备货
      stockupState: '', // 备货状态   1待认领 2待处理 3已处理 4未揽件
      deliverType: '物流配送', // 调拨方式
      totalNumber: 0, // 总件数
      backSignBill: '', // 签收回单
      params: {}, // 德邦快递
      logicType: 2,
      addListParams: {
        addList: [
          {
            logicCompany: '',
            logicNumber: ''
          }
        ]
      },
      collect: {}, // 未揽件页面
      backOut: {}, // 撤销物流
      wareHouse: {},
      Mark: '',
      remark: '',
      conseQuence: {}, // 处理结果
      mark: '', // 发货说明
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      }
    }
  },
  mounted() {
    this.queryStockupContent()
    this.queryStockupContentAllot()
    this.distributionType = Number(this.$route.query.distributionType)
    this.stockupState = Number(this.$route.query.stockupState)
  },
  methods: {
    // 导出备货单
    toExport() {
      const params = {}
      params.distributionType = this.$route.query.distributionType
      params.ocssIds = this.$route.query.ocssIds
      params.ocsId = this.$route.query.id
      if (this.$route.query.distributionType === 1) {
        params.stockUrl = this.$store.state.optionsListGuidwarse
      } else {
        params.stockUrl = this.$store.state.optionsListGuid
      }

      addStorageStockCoeDerive(params)
        .then(res => {
          downLoadFileBlob(this, res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 判断盘点和保存情况
    isCheck({ row, rowIndex }) {
      if (row.isLack === true && row.isCheck === false) {
        return 'warning-row'
      }
    },
    // 根据备货产品id和备货方式distributionType 仓库方案id ocssIds 获取备货详情
    queryStockupContent() {
      queryStockupContent(
        this.$route.query.ocssIds,
        this.$route.query.id,
        this.$route.query.distributionType
      )
        .then(res => {
          if (res.data.code === 200) {
            this.queryParams = res.data.obj.storageStockupVo // 基本信息
            this.list = res.data.obj.storageStockupContentVoList // 备货产品详情
            this.isLack = res.data.obj.storageStockupContentVoList.isLack
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 未揽件- 调拨备货详情页-物流订单管理详情物流订单管理详情
    queryStockupContentAllot() {
      queryStockupContentAllot(
        this.$route.query.ocssIds,
        this.$route.query.id,
        this.$route.query.distributionType
      )
        .then(res => {
          if (res.data.code === 200) {
            this.collect =
              res.data.obj.storageDeliverLogisticAllVo.storageDeliverLogisticBondsVo // 物流订单管理详情
            if (this.collect.transportType) {
              this.tempArr = this.transportation.filter(
                ele => ele.value === this.collect.transportType
              )[0].arr
            }
            this.conseQuence =
              res.data.obj.storageDeliverLogisticAllVo.storageDeliverLogisticsVo.storageDeliverLogisticMessageVo // 德邦快递
            this.wareHouse =
              res.data.obj.storageDeliverLogisticAllVo.storageDeliverLogisticsVo // 仓库配送
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 修改物流备货单
    editLogistics() {
      this.banned = false
    },
    // 修改----返回
    backLogistics() {
      this.banned = true
      this.queryStockupContentAllot()
      this.$refs.queryParamsRefs.clearValidate() // 去掉校验
    },
    onClose() {
      this.banned = true
      this.$refs.queryParamsRefs.clearValidate() // 去掉校验
    },
    // 修改物流备货单完成提示框
    ModifyComplete() {
      this.$refs.queryParamsRefs.validate(valid => {
        if (valid) {
          // 校验通过
          this.disableDialog = true
        } else {
          this.$message.error('校验未通过')
          return false
        }
      })
    },
    //  确认修改完成
    onSubmit() {
      updateStorageDeliverLogisticBond(this.collect)
        .then(res => {
          if (res.data.code === 200) {
            this.queryStockupContentAllot()
            this.banned = true
            this.disableDialog = false
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 撤销快递物流单
    repealLogistics() {
      this.dialogVisible = true
    },
    // 确认撤销提示框
    affirmBackout() {
      this.$refs.queryParamsRefs.validate(valid => {
        if (valid) {
          // 校验通过
          this.backDialog = true
        } else {
          this.$message.error('校验未通过')
          return false
        }
      })
    },
    // 返回
    goBack() {
      this.$refs.queryParamsRefs.clearValidate() // 去掉校验
      this.dialogVisible = false
    },
    // 关闭对话框
    close() {
      this.$refs.queryParamsRefs.clearValidate() // 去掉校验
    },
    // 撤销确认
    onBackSubmit() {
      deleteStorageDeliverBond(this.collect.sodlbId, this.collect.Mark)
        .then(res => {
          if (res.data.code === 200) {
            this.dialogVisible = false
            this.backDialog = false
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 撤销取消
    cancle() {
      this.backDialog = false // 关闭当前对话框
      this.editDialog = true // 显示修改物流备货单对话框
    },
    // 设置头部颜色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },

    // 确认备货
    onSureStock() {
      const params = {
        storageDeliverLogisticVo: {
          logicType: this.logicType,
          storageDeliverLogisticBondVo: {},
          storageLogisticsVoList: []
        },
        storageStockupContentVoList: this.list,
        arrivalTime: this.queryParams.arrivalTime, // 预计到达日期
        deliverType: this.deliverType, // 调拨方式
        ocsId: this.$route.query.id, // 备货清单id
        sbId: this.queryParams.sbId, // 仓库id
        mark: this.queryParams.remark // 发货说明
      }
      if (this.deliverType !== '仓库配送' && this.logicType === 2) {
        let CompaFalse = false
        let NumFalse = false
        this.addListParams.addList.forEach(ele => {
          if (!ele.logicCompany) {
            CompaFalse = true
          }
          if (!ele.logicNumber) {
            NumFalse = true
          }
        })
        if (CompaFalse) {
          this.$message.error('物流公司不能为空')
        } else if (NumFalse) {
          this.$message.error('物流单号不能为空')
        } else {
          params.storageDeliverLogisticVo.storageLogisticsVoList = this.addListParams.addList
          this.$refs.sureStockTipRefs.onInitialize(
            params,
            2,
            this.$route.query.id,
            this.$route.query.ocssIds
          )
        }
      } else {
        this.$refs.paramsRefs.validate(valid => {
          if (valid) {
            params.storageDeliverLogisticVo.storageDeliverLogisticBondVo = this.params
            this.$refs.sureStockTipRefs.onInitialize(
              params,
              2,
              this.$route.query.id,
              this.$route.query.ocssIds
            )
          }
        })
      }
    },
    // 已处理页
    entryProcessed() {
      this.queryStockupContentAllot()
      this.queryStockupContent()
      this.stockupState = 3
    },
    entryLogistics() {
      this.queryStockupContentAllot()
      this.queryStockupContent()
      this.stockupState = 4
    },

    // 跳产品详情页
    detailModel(row) {
      this.$router.push({
        path: '/product/productManage/productDetails',
        query: { id: row.proId }
      })
    },
    // 循环添加form 表单
    toAddLogistic(list) {
      list.push({})
    },
    // 删除form表单中某一条
    toDelLogistic(list, index) {
      list.splice(index, 1)
    },
    // 快递公司
    selectCompany(val) {
      this.logicType = val
    },
    // 下单模式
    selectOrderType(orderType) {
      this.orderType = orderType
    },
    // 运输方式
    selectTransportType(val) {
      this.transportType = val
      this.tempArr = this.transportation.filter(ele => ele.value === val)[0].arr
    },
    // 产品类型val
    selectProductType(val) {
      this.productType = val
    },
    // 送货方式
    selectDeliveryType(deliveryType) {
      this.deliveryType = deliveryType
    },
    // 支付方式
    selectPayType(payType) {
      this.payType = payType
    },
    // 签收回单
    selectBackSignBill(backSignBill) {
      this.backSignBill = backSignBill
    },

    // 报缺侧边栏
    toVacancy(row) {
      this.$refs.sureStockTipsRefs.onInitialize(row)
    },
    // 存在盘点无法报缺
    colorVacancy($index, row) {
      this.checkDialog = true
    },
    // 报缺返回
    getListRef() {
      this.queryStockupContent()
      this.queryStockupContentAllot()
      this.distributionType = Number(this.$route.query.distributionType)
      this.stockupState = Number(this.$route.query.stockupState)
    }
  }
}
</script>
<style
  lang="scss"
  scoped
>
.add-basic-information .bottom {
  padding: 0 30px 30px 30px;
}

.add-basic-information .bottom-tip {
  margin: 15px 0;
}

.add-title1 {
  display: flex;
  justify-content: space-between;
  padding: 30px 0 0 30px;
}

.logistics-information {
  font-size: 16px;
  font-weight: bold;
  color: #4e555b;
  margin-bottom: 10px;
}
.el-button+.el-button {
  margin-left: 0 !important;
}
</style>
